import { render, staticRenderFns } from "./Telescope.vue?vue&type=template&id=7d89ff6a&scoped=true"
import script from "./Telescope.vue?vue&type=script&lang=js"
export * from "./Telescope.vue?vue&type=script&lang=js"
import style0 from "./Telescope.vue?vue&type=style&index=0&id=7d89ff6a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d89ff6a",
  null
  
)

export default component.exports